// Where a `fixed` popup menu goes, against the viewport. Pure, so the rules are tested without a DOM: below the
// button, right-aligned, or above it when there is more room there; never taller than the room it has (the popup
// scrolls inside instead, so its last items stay reachable on a phone); and when the page scrolls under it, it
// follows its button, closing only once the button has left the viewport.

/** Room a popup wants below the button before it opens upwards instead. */
export const FIXED_ROOM = 260;
/** The smallest height a popup gets, however little room there is. */
const MIN_HEIGHT = 96;
const GAP = 4;
const EDGE = 8;

export interface Place {
  top?: number;
  bottom?: number;
  right: number;
  /** the popup scrolls inside past this height */
  maxHeight: number;
}

export interface AnchorRect {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

export function placeMenu(r: AnchorRect, vw: number, vh: number): Place {
  const right = Math.max(EDGE, vw - r.right);
  const below = vh - r.bottom - GAP - EDGE;
  const above = r.top - GAP - EDGE;
  return below < FIXED_ROOM && above > below
    ? { bottom: vh - r.top + GAP, right, maxHeight: Math.max(MIN_HEIGHT, above) }
    : { top: r.bottom + GAP, right, maxHeight: Math.max(MIN_HEIGHT, below) };
}

/** The page scrolled or resized under an open popup: its new place, or null to close (its button is gone). */
export function replaceMenu(r: AnchorRect, vw: number, vh: number): Place | null {
  if (r.bottom <= 0 || r.top >= vh || r.right <= 0 || r.left >= vw) return null;
  return placeMenu(r, vw, vh);
}
